import { FgPriceListCategoryEnum } from "../enums"

export class ProductAndCategoryReq{
    productId:number
    category: FgPriceListCategoryEnum

    constructor(productId:number,category: FgPriceListCategoryEnum){
        this.productId = productId
        this.category = category
    }
}